<template>
    <section>
      <div class="login-container">
        <div class="title-app">
          <h2>SAP</h2>
          <h1>Sistema de Administración de Personal</h1>
          <h4>Administracion de Servicios Portuarios - Bolivia</h4>
        </div>
        
        <v-card class="login-form">
          <v-form @submit.prevent="submit" v-model="valid" ref="form">
            <v-card-title primary-title>
              <h4>Recuperar Contraseña</h4>
              <v-container fluid>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-alert v-if="message" :type="alertType" value="true" class="mb-3">
                      {{ message }}
                    </v-alert>
                    
                    <v-text-field
                      name="email"
                      label="Correo Electrónico"
                      id="email"
                      append-icon="email"
                      v-model="form.email"
                      type="email"
                      autofocus
                      :rules="$validate(['required', 'email'])"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-title>
            
            <v-card-actions>
              <v-btn color="primary" block large :disabled="!valid || loading" type="submit">
                <v-progress-circular v-if="loading" indeterminate size="20" class="mr-2"></v-progress-circular>
                {{ loading ? 'Enviando...' : 'Enviar Instrucciones' }}
              </v-btn>
            </v-card-actions>
            
            <v-card-title>
              <v-container fluid>
                <v-layout row class="login-options">
                  <v-flex xs12 class="text-xs-center">
                    <a @click="$router.push('/login')">
                      <v-icon>arrow_back</v-icon> Volver al Login
                    </a>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-title>
          </v-form>
        </v-card>
      </div>
    </section>
  </template>
  
  <script>
  import validate from "@/common/mixins/validate";
  
  export default {
    mixins: [validate],
    data() {
      return {
        valid: true,
        loading: false,
        message: '',
        alertType: 'info',
        form: {
          email: ""
        }
      };
    },
    methods: {
      async submit() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.message = '';
          
          try {
            await this.requestPasswordReset(this.form.email);
            this.message = 'Se han enviado las instrucciones para restablecer tu contraseña a tu correo electrónico.';
            this.alertType = 'success';
          } catch (error) {
            this.message = this.getErrorMessage(error);
            this.alertType = 'error';
          } finally {
            this.loading = false;
          }
        }
      },
      
      async requestPasswordReset(email) {
        // Configuración de Keycloak
        const keycloakConfig = {
          realm: 'tu-realm', // Reemplaza con tu realm
          clientId: 'tu-client-id', // Reemplaza con tu client ID
          url: 'https://tu-keycloak-server.com' // Reemplaza con tu URL de Keycloak
        };
        
        // Endpoint de Keycloak para recuperación de contraseña
        const resetUrl = `${keycloakConfig.url}/realms/${keycloakConfig.realm}/protocol/openid-connect/auth`;
        
        // Parámetros para la solicitud de reset
        const params = new URLSearchParams({
          client_id: keycloakConfig.clientId,
          redirect_uri: `${window.location.origin}/reset-password`, // Ajusta según tu configuración
          response_type: 'code',
          scope: 'openid',
          kc_action: 'UPDATE_PASSWORD'
        });
        
        // Alternativa: Usar el endpoint directo de recuperación
        // Esta es la forma más común con Keycloak
        const recoveryUrl = `${keycloakConfig.url}/realms/${keycloakConfig.realm}/login-actions/reset-credentials?client_id=${keycloakConfig.clientId}`;
        
        // Redirigir a la página de recuperación de Keycloak
        window.location.href = recoveryUrl;
        
        // O si prefieres hacerlo via API (depende de la configuración de Keycloak)
        // return await this.sendResetEmailAPI(email);
      },
      
      async sendResetEmailAPI(email) {
        // Método alternativo si Keycloak está configurado para permitir API calls
        try {
          const response = await fetch(`${this.getKeycloakBaseUrl()}/realms/${this.getRealm()}/login-actions/reset-credentials`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
              username: email,
              client_id: this.getClientId()
            })
          });
          
          if (!response.ok) {
            throw new Error('Error al enviar solicitud de recuperación');
          }
          
          return await response.json();
        } catch (error) {
          console.error('Error en recuperación de contraseña:', error);
          throw error;
        }
      },
      
      getErrorMessage(error) {
        if (error.message.includes('network') || error.message.includes('fetch')) {
          return 'Error de conexión. Por favor, intente nuevamente.';
        }
        return 'Error al enviar la solicitud. Por favor, verifique su correo electrónico.';
      },
      
      getKeycloakBaseUrl() {
        return 'https://tu-keycloak-server.com'; // Reemplaza con tu URL
      },
      
      getRealm() {
        return 'tu-realm'; // Reemplaza con tu realm
      },
      
      getClientId() {
        return 'tu-client-id'; // Reemplaza con tu client ID
      }
    }
  };
  </script>
  
  <style scoped>
  .login-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 20px;
  }
  
  .login-form {
    width: 100%;
    max-width: 400px;
  }
  
  .title-app {
    text-align: center;
    margin-bottom: 30px;
  }
  
  .title-app h2 {
    font-size: 2.5rem;
    margin-bottom: 10px;
  }
  
  .title-app h1 {
    font-size: 1.5rem;
    margin-bottom: 5px;
  }
  
  .title-app h4 {
    font-size: 1rem;
    color: #666;
  }
  </style>


// WEBPACK FOOTER //
// src/components/admin/auth/PasswordRecovery.vue